/* eslint no-console: 0 */
import Phaser from 'phaser'
import Actor from '@/phaser/lib/actor'

import mara from '@/assets/chara/mara.png'
import leafCursor from '@/assets/ui/cursor/leaf.png'
import knollhurstLayer0 from '@/assets/map/knollhurst/knollhurst-layer-0.png'

import maraAtlas from '@/assets/chara/mara.json'
import tiledKnollhurst from '@/assets/map/knollhurst/knollhurst.json'


// for tilemap collisions
// http://labs.phaser.io/edit.html?src=src\game%20objects\tilemap\collision\matter%20ghost%20collisions.js

// https://labs.phaser.io/edit.html?src=src\game%20objects\tilemap\static\tileset%20collision%20shapes.js

// get the shapes, then for every shape, create a body with the matter factory
// https://photonstorm.github.io/phaser3-docs/Phaser.Physics.Matter.Factory.html
// this.matter.add.rectangle(x, y, width, height);
// circle(x, y, radius [, options] [, maxSides])
// 
// fromVertices(x, y, vertexSets [, options] [, flagInternal] [, removeCollinear] [, minimumArea])
// https://github.com/photonstorm/phaser/blob/v3.22.0/src/physics/matter-js/Factory.js#L187

//mouse keyboard + touch hold
// http://labs.phaser.io/view.html?src=src\input\multitouch\two%20touch%20inputs.js
// http://127.0.0.1:8081/view.html?src=src/2019-01/005%20follow%20pointer.js&rnd=1581400315638

export default class KnollhurstMovement extends Phaser.Scene {
  constructor () {
    super()

    this.mara
    this.stick
    this.debugGraphic
    this.debugText
    window.game = this
  }

  preload () {
    console.log('try loading assets async', mara)
    this.load.atlas('mara', mara, maraAtlas)

    this.load.tilemapTiledJSON('map', tiledKnollhurst)
    this.load.image('knollhurst-layer-0', knollhurstLayer0)
  }

  create () {
    let scene = this
    scene.game.forceSingleUpdate = false
    scene.matter.set60Hz()

    console.log('creating...')

    this.map = this.make.tilemap({ key: 'map', tileWidth: 10, tileHeight: 10})
    this.tileset = this.map.addTilesetImage('knollhurst-layer-0', 'knollhurst-layer-0', 10, 10, 0, 0, 0)
    let layer = this.map.createStaticLayer('layer-0', this.tileset, 0, 0)


    var graphics = this.add.graphics()

    let tileset = this.tileset
    // Loop over each tile and visualize its collision shape (if it has one)
    layer.forEachTile(function (tile) {
      var tileWorldPos = layer.tileToWorldXY(tile.x, tile.y)
      var collisionGroup = tileset.getTileCollisionGroup(tile.index)

      if (!collisionGroup || collisionGroup.objects.length === 0)
        return

      if (collisionGroup.properties && collisionGroup.properties.isInteractive)
        graphics.lineStyle(5, 0x00ff00, 1)
      else
        graphics.lineStyle(5, 0x00ffff, 1)

      // The group will have an array of objects - these are the individual collision shapes
      var objects = collisionGroup.objects

      for (var i = 0; i < objects.length; i++) {
        var object = objects[i]
        var objectX = tileWorldPos.x + object.x
        var objectY = tileWorldPos.y + object.y

        // When objects are parsed by Phaser, they will be guaranteed to have one of the
        // following properties if they are a rectangle/ellipse/polygon/polyline.
        if (object.rectangle) {
          graphics.strokeRect(objectX, objectY, object.width, object.height);
        } else if (object.ellipse) {
          // Ellipses in Tiled have a top-left origin, while ellipses in Phaser have a center
          // origin
          graphics.strokeEllipse(
            objectX + object.width / 2, objectY + object.height / 2,
            object.width, object.height
          )
        } else if (object.polygon || object.polyline) {
          var originalPoints = object.polygon ? object.polygon : object.polyline
          var points = []
          for (var j = 0; j < originalPoints.length; j++) {
            var point = originalPoints[j];
            points.push({
              x: objectX + point.x,
              y: objectY + point.y
            })
          }
          graphics.strokePoints(points)
        }
      }
    })



    //let background = this.add.image(0, 0, 'knollhurst-layer-0').setOrigin(0, 0)

    this.input.setDefaultCursor(`url(${leafCursor}), pointer`);
    this.cameras.main.setBounds(0, 0, this.tileset.glTexture.width, this.tileset.glTexture.height)

    //this.matter.world.setBounds(0, 0, 1920, 1080)

    //up and down should be 11 fps
    this.anims.create({
      key: 'runLeft',
      frameRate: 13,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistRunLeft',
          end: 9, 
          zeroPad: 3
        }
      ),
      repeat: -1
    })
    this.anims.create({
      key: 'runRight',
      frameRate: 13,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistRunRight',
          end: 9, 
          zeroPad: 3
        }
      ),
      repeat: -1
    })
    this.anims.create({
      key: 'runUp',
      frameRate: 11,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistRunUp',
          end: 9, 
          zeroPad: 3
        }
      ),
      repeat: -1
    })
    this.anims.create({
      key: 'runDown',
      frameRate: 11,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistRunDown',
          end: 9, 
          zeroPad: 3
        }
      ),
      repeat: -1
    })

    this.anims.create({
      key: 'idleLeft',
      frameRate: 1,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistIdleLeft',
          end: 0, 
          zeroPad: 1
        }
      ),
      repeat: -1
    })
    this.anims.create({
      key: 'idleRight',
      frameRate: 1,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistIdleRight',
          end: 0, 
          zeroPad: 1
        }
      ),
      repeat: -1
    })
    this.anims.create({
      key: 'idleUp',
      frameRate: 1,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistIdleUp',
          end: 0, 
          zeroPad: 1
        }
      ),
      repeat: -1
    })
    this.anims.create({
      key: 'idleDown',
      frameRate: 1,
      frames: this.anims.generateFrameNames(
        'mara', 
        {
          prefix: 'fistIdleDown',
          end: 0, 
          zeroPad: 1
        }
      ),
      repeat: -1
    })

    this.mara = new Actor({
      scene,
      x: this.tileset.glTexture.width * .5,
      y: this.tileset.glTexture.height * .5,
      texture: 'mara',
      stats: {
        speed: 3
      }
    })

    this.cameras.main.startFollow(this.mara, true, .4, .4)

    console.log(this.mara)
    console.log(this.anims)
    this.mara.anims.play('runLeft', true)

    this.input.on('drag', function (pointer) {
      if(pointer.downTime)
        scene.mara.moveTo(
          pointer.x + scene.cameras.main.scrollX, 
          pointer.y + scene.cameras.main.scrollY
        )
      else
        scene.mara.stop()
    })

    this.input.on('pointermove', function (pointer) {
      if(pointer.isDown)
        scene.mara.moveTo(
          pointer.x + scene.cameras.main.scrollX,
          pointer.y + scene.cameras.main.scrollY
        )
    })

    this.input.on('pointerdown', function (pointer) {
      scene.mara.moveTo(
        pointer.x + scene.cameras.main.scrollX, 
        pointer.y + scene.cameras.main.scrollY,
        true
      )
    })

    this.input.on('pointerup', function() {
      scene.mara.stop()
    })

    console.log('finished creating')
  }

  update (time, delta) {
    let pointer = this.input.activePointer
    this.mara.update({
      time, 
      delta,
      pointer
    })
  }
}
